import DsLinkButton, { LinkButtonProps } from '@carvana/ds-link-button';
import React from 'react';
import { useBrand } from '|/brand';
import titleCaseChildren from '|/components/carvana-ds/title-case-children';

const LinkButton: React.FC<LinkButtonProps> = ({ children, underline, ...rest }) => {
  const { brand } = useBrand();
  return (
    <DsLinkButton {...rest} underline={brand === 'slate' ? true : underline}>
      {brand === 'slate' ? titleCaseChildren(children) : children}
    </DsLinkButton>
  );
};

export default LinkButton;
export type { LinkButtonProps };
